import React, { useState, useEffect } from "react";
import moment from "moment";
import InfiniteScroll from "react-infinite-scroll-component";
import LearningPathCard from "../../cards/LearningPathCard";
import { useAdminGetUserLearningTracksQuery } from "../../../services/organization/adminUsers";
import LoadingIndicator from "../../LoadingIndicator";
import { useTranslation } from "react-i18next";

export default function LearningLevel({ user }) {
  const [allLearningTracks, setAllLearningTracks] = useState([]);
  const [page, setPage] = useState(1);
  const { t } = useTranslation(["common"]);
  const { data: learningTracks, isLoading: isGetUserLearningTracksLoading } =
    useAdminGetUserLearningTracksQuery({
      userId: user?.id,
      page,
    });

  useEffect(() => {
    if (learningTracks?.data?.length) {
      if (learningTracks?.pagination?.current == 1) {
        setAllLearningTracks(learningTracks?.data);
      } else {
        setAllLearningTracks((prev) => {
          return [...prev, ...learningTracks?.data];
        });
      }
    } else if (learningTracks?.pagination?.current == 1) {
      setAllLearningTracks([]);
    }
  }, [learningTracks]);

  if (isGetUserLearningTracksLoading) return <LoadingIndicator />;

  return (
    <div className="profile-about admin-employee-profile__learning-paths">
      <h1 className="mb-1 font_20 head-text-title font-extrabold">
        {t("learningPathsTitle")}
      </h1>
      <p className="mb-4 font_14 font-color-grey font-bold">
        {t("recentlySubscribedLearningPaths", {
          count: learningTracks?.pagination?.count ?? 0,
        })}
      </p>

      {allLearningTracks?.length ? (
        <InfiniteScroll
          className="admin-employee-profile__learning-paths-list"
          dataLength={allLearningTracks.length}
          next={() => setPage(learningTracks?.pagination?.next)}
          hasMore={!!learningTracks?.pagination?.next}
          loader={
            <h4 className="admin-employee-profile__learning-paths-loader">
              {t("Loading")}
            </h4>
          }
          endMessage={
            <p className="admin-employee-profile__end-message">
              {t("successfulLearningPathDisplay")}
            </p>
          }
          style={{ overflow: "unset" }}
        >
          {allLearningTracks.map((learningTrack) => {
            const ProgressBarPercentage = `${learningTrack?.enrollment?.progress}%`;
            const subscribedDate = moment(new Date(learningTrack?.created_at));
            const completeDate = moment(
              new Date(learningTrack?.enrollment?.complete_by),
            );
            const oneDay = 24 * 60 * 60 * 1000;
            const remainingDays = Math.round(
              (completeDate - new Date()) / oneDay,
            );

            return (
              <div
                key={learningTrack?.id}
                className="admin-employee-profile__learning-paths-item"
              >
                <LearningPathCard
                  id={learningTrack?.id}
                  title={learningTrack?.title}
                  image={learningTrack?.image_url}
                  ProgressBarPercentage={ProgressBarPercentage}
                  ProgressBarWidth="50%"
                  coursesCounts={learningTrack?.courses_count}
                  completedCoursesCount={
                    learningTrack?.enrollment?.completed_courses_count
                  }
                  subscribedAt={subscribedDate.format("DD / MM / YYYY")}
                  completeBy={completeDate.format("DD / MM / YYYY")}
                  remainingDays={remainingDays}
                  isArchived={learningTrack?.archived}
                  isAdmin
                />
              </div>
            );
          })}
        </InfiniteScroll>
      ) : (
        <p className="admin-employee-profile__empty-state">
          {t("emptyStates.learningPaths")}
        </p>
      )}
    </div>
  );
}
